import api from "../../api";

export const getWithdrawls = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/partner/withdrawl?${query}`);
    return data
  } else {
    const { data } = await api.get('billing/partner/withdrawl');
    return data
  }
}

export const getOpenedWithdrawls = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/partner/withdrawl?status=1&${query}`);
    return data
  } else {
    const { data } = await api.get('billing/partner/withdrawl?status=1');
    return data
  }
}

export const getFinishedWithdrawls = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/partner/withdrawl?status=2&${query}`);
    return data
  } else {
    const { data } = await api.get('billing/partner/withdrawl?status=2');
    return data
  }
}

export const getBankAccounts = async () => {
  const { data } = await api.get(`bank_account/`);
  return data
}

export const newAccountBank = async (params: any) => {
  const { data } = await api.post(`bank_account/`, params);
  return data
}

export const updateAccountBank = async (id: any, params: any) => {
  const { data } = await api.put(`bank_account/${id}`, params);
  return data
}

export const removeAccountBank = async (id: any) => {
  const { data } = await api.delete(`bank_account/${id}`);
  return data
}

export const getAllBanks = async () => {
  const { data } = await api.get(`/bank/`);
  return data
}

export const confirmPassword = async (password: string) => {
  const { data } = await api.post(`password_confirm/`, {password: password});
  return data
}

export const newWithdrawl = async (params: any) => {
  let formData = new FormData();
  formData.append("account_bank", params.account_bank);
  formData.append("value", params.value);
  formData.append("type", params.type);
  formData.append("file", params.file);

  const { data } = await api.post(`billing/partner/withdrawl/`, formData);
  return data
}